<template>
  <v-list-item>
    <v-list-item-content>
      {{ shItem.reference.name }} 
      - 
      {{ shItem.product.name }} 
      - 
      <v-chip
        x-small
        :class="isBright(shItem.color.hexacode) ? 'outlined' : ''"
        :color="shItem.color.hexacode"
        style="width: 20px"
      ></v-chip><span class="fs12"> {{ shItem.color.name }}</span>
      - 
      <b>x {{ shItem.quantity }}</b>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  // MIXINS
  import utils from '@/mixins/utils'

  export default {
    name: 'ShippingHistoryItem',

    mixins: [utils],

    props: {
      shItem: Object,
    }
  }
</script>

<style scoped>
  .v-list-item__content {
    display: block;
  }
  .v-list-item {
    padding-left: 40px !important;
  }
</style>